<script>
import ExpressistTransporterService from '@/services/transporters/ExpressistTransporterService'
import { handleResponseError } from '@/components/utils/globalFunction'

export default {
  name: 'ExpressistConnexionDetailPage',
  data() {
    return {
      expressistConnexionLink: null,
      expressistConnexionLinkId: null
    }
  },
  async created() {
    this.expressistConnexionLinkId = this.$route.params.expressistConnexionLinkId
    await this.getExpressistTransporterConnexionLinkById(this.expressistConnexionLinkId)
  },
  methods: {
    async getExpressistTransporterConnexionLinkById(expressistConnexionLinkId) {
      try {
        this.expressistConnexionLink
          = await ExpressistTransporterService
          .getExpressistTransporterConnexionLinkById(expressistConnexionLinkId)
      } catch (error) {
        handleResponseError(error)
      }
    },
    goToUpdate() {
      this.$router.push('/dashboard/transporters/expressist/update/'
        + this.expressistConnexionLink?.connexion.technical_id)
    },
    getSubtitle() {
      return this.$t('EXPRESSIST_TRANSPORTER.DETAIL_PAGE.TITLE.SUBTITLE',
        { transporter_name: this.expressistConnexionLink?.connexion.transporter.name })
    }
  }
}
</script>

<template>
  <v-container fluid>
    <!--HEADER-->
    <div class="d-flex flex-column flex-md-row justify-space-between">
      <div>
        <h1>{{ $t('EXPRESSIST_TRANSPORTER.DETAIL_PAGE.TITLE.HEADER') }}</h1>
        <span>{{ getSubtitle() }}</span>
      </div>

      <div class="d-flex align-center justify-md-center justify-start mt-8 mt-md-0">
        <v-btn
          class="boom-button-back"
          :to="'/dashboard/transporters'"
          variant="outlined"
        >
          {{ $t('COMMON.BUTTON.BACK') }}
        </v-btn>
        <v-btn
          class="boom-button ml-2"
          @click=goToUpdate()
          variant="outlined"
        >
          {{ $t('COMMON.BUTTON.UPDATE') }}
        </v-btn>
      </div>
    </div>

    <!--Transporter connexion link information if exist-->
    <div v-if="expressistConnexionLink !== null">
      <v-card class="rounded-xl mt-8" :border="false" :elevation="0">
        <v-row>
          <v-col cols="12">
            <h3 class="font-weight-bold">{{ $t('EXPRESSIST_TRANSPORTER.DETAIL_PAGE.TITLE.GENERAL_INFORMATION') }}</h3>
          </v-col>
        </v-row>

        <v-row>
          <!--Transporter name-->
          <v-col cols="12" md="3">
            <p class="font-weight-bold">{{ $t('EXPRESSIST_TRANSPORTER.DETAIL_PAGE.LABEL.TRANSPORTER_NAME') }}</p>
            <p>{{ expressistConnexionLink?.connexion.transporter.name }}</p>
          </v-col>

          <!--Transporter type-->
          <v-col cols="12" md="3">
            <p class="font-weight-bold">{{ $t('EXPRESSIST_TRANSPORTER.DETAIL_PAGE.LABEL.TRANSPORTER_TYPE') }}</p>
            <p>{{ expressistConnexionLink?.connexion.transporter.transporter_type }}</p>
          </v-col>
        </v-row>

        <v-row>
          <!--Transporter weight_max-->
          <v-col cols="12" md="3">
            <p>{{ $t('EXPRESSIST_TRANSPORTER.DETAIL_PAGE.LABEL.TRANSPORTER_WEIGHT') }}</p>
            <p class="font-weight-bold">{{ expressistConnexionLink?.connexion.transporter.weight_max }}</p>
          </v-col>

          <!--Transporter power_max-->
          <v-col cols="12" md="3">
            <p>{{ $t('EXPRESSIST_TRANSPORTER.DETAIL_PAGE.LABEL.TRANSPORTER_POWER') }}</p>
            <p class="font-weight-bold">{{ expressistConnexionLink?.connexion.transporter.power_max }}</p>
          </v-col>

          <!--Transporter height_max-->
          <v-col cols="12" md="3">
            <p>{{ $t('EXPRESSIST_TRANSPORTER.DETAIL_PAGE.LABEL.TRANSPORTER_HEIGHT') }}</p>
            <p class="font-weight-bold">{{ expressistConnexionLink?.connexion.transporter.height_max }}</p>
          </v-col>

          <!--Transporter width_max-->
          <v-col cols="12" md="3">
            <p>{{ $t('EXPRESSIST_TRANSPORTER.DETAIL_PAGE.LABEL.TRANSPORTER_WIDTH') }}</p>
            <p class="font-weight-bold">{{ expressistConnexionLink?.connexion.transporter.width_max }}</p>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="rounded-xl mt-8" :border="false" :elevation="0">
        <v-row>
          <v-col cols="12">
            <h3 class="font-weight-bold">
              {{ $t('EXPRESSIST_TRANSPORTER.DETAIL_PAGE.TITLE.CONNEXION_GENERAL_INFORMATION') }}
            </h3>
          </v-col>
        </v-row>

        <v-row>
          <!--Connexion name-->
          <v-col cols="12">
            <p class="font-weight-bold">{{ $t('EXPRESSIST_TRANSPORTER.DETAIL_PAGE.LABEL.CONNEXION_NAME') }}</p>
            <p>{{ expressistConnexionLink?.connexion.connexion_name }}</p>
          </v-col>
        </v-row>

        <v-row>
          <!--Connexion identifier-->
          <v-col cols="6">
            <p class="font-weight-bold">{{ $t('EXPRESSIST_TRANSPORTER.DETAIL_PAGE.LABEL.CONNEXION_IDENTIFIER') }}</p>
            <p>{{ expressistConnexionLink?.connexion.login }}</p>
          </v-col>

          <!--Connexion password-->
          <v-col cols="6">
            <p class="font-weight-bold">{{ $t('EXPRESSIST_TRANSPORTER.DETAIL_PAGE.LABEL.CONNEXION_PASSWORD') }}</p>
            <p>*****</p>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <p class="font-weight-bold">{{ $t('EXPRESSIST_TRANSPORTER.DETAIL_PAGE.LABEL.CONNEXION_SERVICE') }}</p>
            <div class="service-list">
              <div v-for="service in expressistConnexionLink?.connexion.service_list"
                   :key="service.technical_id">
                <v-chip size="small">
                  <span>{{ service.code }} - {{ service.name }}</span>
                </v-chip>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <!--Priority-->
          <v-col cols="4">
            <p class="font-weight-bold">{{ $t('EXPRESSIST_TRANSPORTER.DETAIL_PAGE.LABEL.LINK_PRIORITY') }}</p>
            <p>{{ expressistConnexionLink?.link_priority === true ? $t('COMMON.BUTTON.YES') : $t('COMMON.BUTTON.NO') }}</p>
          </v-col>
        </v-row>
      </v-card>
    </div>

    <div v-if="expressistConnexionLink === null">
      <v-card class="rounded-xl mt-8" :border="false" :elevation="0">
        <v-row>
          <v-col cols="12">
            <h4>{{ $t('EXPRESSIST_TRANSPORTER.DETAIL_PAGE.TITLE.NO_TRANSPORTER') }}</h4>
          </v-col>
        </v-row>
      </v-card>
    </div>
  </v-container>
</template>

<style scoped>
.v-card {
  padding: 32px;
}

.service-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  justify-content: flex-start;
}
</style>
